/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ContactInputFields} from "./contactInputFields.zod";
import {PhoneNumberInput} from "./phoneNumberInput.zod";

export const ContactInput = ContactInputFields.and(
  zod.union([
    zod.object({
      email: zod.string(),
    }),
    zod.object({
      phone: PhoneNumberInput,
    }),
  ]),
);

export type ContactInput = zod.input<typeof ContactInput>;
export type ContactInputOutput = zod.output<typeof ContactInput>;
